<template>
  <q-col :span="8">
    <q-panel :header-text="this.$qt('blog.searchPanelText')">
      <div class="panel-padding">
        <q-input v-model="word">
          <q-button
            slot="append"
            @click="search"
          >
            <font-awesome-icon :icon="['fas', 'search']" />
          </q-button>
        </q-input>
      </div>
    </q-panel>
    <q-panel :header-text="this.$qt('blog.categoriesPanelText')">
      <div class="panel-padding">
        <q-tree
          ref="allCategories"
          class="filter-tree"
          :data="categories"
          :props="defaultProps"
          default-expand-all
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
        />
      </div>
    </q-panel>
  </q-col>
</template>

<script>
  export default {
    name: "CategoriesAndSearchColumn",

    props: {
      categories: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        word: '',

        filterText: '',
        currentCategory: {},
        defaultProps: {
          children: 'childes',
          label: 'title'
        }
      };
    },

    watch: {
      filterText(val) {
        this.$refs.allCategories.filter(val);
      }
    },

    methods: {
      search() {
        if (this.word)
          this.$router.push({name: 'search', params: {word: this.word}});
        else
          this.$router.push({name: 'posts', params: {category: 'all'}});
      },

      filterNode(value, data) {
        if (!value) return true;
        return data.title.indexOf(value) !== -1;
      },
      handleNodeClick(data) {
        this.currentCategory = data;


        let params = {
          category: this.currentCategory.key
        };
        this.$router.push({
          name: 'posts', params: params
        });
      }
    }
  }
</script>

<style scoped>

</style>